import(/* webpackMode: "eager" */ "/tmp/8dee8231af5a4f4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee8231af5a4f4/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Nunito_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"600\",\"700\"]}],\"variableName\":\"nunito_sans\"}");
;
import(/* webpackMode: "eager" */ "/tmp/8dee8231af5a4f4/src/app/globals.css");
